/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { _activateOption } from '../../../utils/select-box/option/activate';
import { _destroyComponent, _insertComponent } from '../../../utils/component/lifecycle';
import { _selectOption } from '../../../utils/select-box/option/select';
import { deregisterElement, registerElement } from '../../../utils/registration/element';
import { receiveValue } from '../../../utils/component/value';
import isSelected from '../../../utils/shared/selected';
import buildAPI from '../../../utils/shared/api';
import buildId from '../../../utils/shared/id';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
let SelectBoxOption = (_class = class SelectBoxOption extends Component {
  get api() {
    return buildAPI(this, ['element', 'index', 'isActive', 'isDisabled', 'isFulfilled', 'isPending', 'isRejected', 'isSelected', 'isSettled', 'value']);
  }
  get id() {
    return buildId(this);
  }
  get index() {
    return this.args.selectBox ? this.args.selectBox.option.indexOf(this) : -1;
  }
  get isActive() {
    return this.args.selectBox ? this.index === this.args.selectBox.activeOptionIndex : false;
  }
  get isDisabled() {
    return !!this.args.disabled;
  }
  get isSelected() {
    return isSelected(this);
  }
  constructor() {
    super(...arguments);
    _defineProperty(this, "element", null);
    _defineProperty(this, "previousValue", null);
    _defineProperty(this, "sealedAPI", {});
    _defineProperty(this, "valueId", 0);
    _initializerDefineProperty(this, "isFulfilled", _descriptor, this);
    _initializerDefineProperty(this, "isPending", _descriptor2, this);
    _initializerDefineProperty(this, "isRejected", _descriptor3, this);
    _initializerDefineProperty(this, "isSettled", _descriptor4, this);
    _initializerDefineProperty(this, "value", _descriptor5, this);
    receiveValue(this);
  }
  handleInsertElement(element) {
    registerElement(this, element);
    _insertComponent(this);
  }
  handleDestroyElement() {
    deregisterElement(this);
    _destroyComponent(this);
  }
  handleUpdateValue() {
    receiveValue(this);
  }
  handleMouseEnter() {
    _activateOption(this);
  }
  handleFocus() {
    _activateOption(this);
  }
  handleClick() {
    _selectOption(this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isFulfilled", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isPending", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isRejected", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isSettled", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "value", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleInsertElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInsertElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDestroyElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDestroyElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleUpdateValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUpdateValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMouseEnter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMouseEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleFocus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _class);
export { SelectBoxOption as default };